/**
 * @module constants
 */

export default {
  A_Z: 'A_Z',
  Z_A: 'Z_A',
  MOST_RECENT: 'MOST_RECENT',
  LEAST_RECENT: 'LEAST_RECENT'
};



// WEBPACK FOOTER //
// ./app/constants/sortOptions.js